import {app} from '../../app';
import {ISessionService} from "../../services/SessionService";
export class ForceRankQuestionPreviewComponent {

    protected sessionService:ISessionService;

    question:IQuestion;
    value:string[] = [];

    choices:string[] = [];
    rows:string[] = [];

    static $inject = ['SessionService'];

    constructor(sessionService:ISessionService) {
        this.sessionService = sessionService;
    }

    $onInit() {
        this.choices = this.question.meta.choices;
        if (!this.choices) {
            this.choices = ["Most Like Me", "Least Like Me"];
        }
        for (let choice of this.choices) {
            this.value.push("");
        }

        this.rows = this.question.meta.rows;
        if (!this.rows) {
            throw new Error("No rows found!");
        }

        let defaultValues = this.question.meta.default;
        if (defaultValues && angular.isArray(defaultValues)) {
            for (let defaultValue of defaultValues) {
                if (defaultValue['choice'] && defaultValue['row']) {
                    let choice = defaultValue['choice'];
                    this.value[choice] = defaultValue['row'];
                }
            }
        }

        let answer = this.sessionService.getAnswer(this.question.id);
        if (answer && answer.values.length > 0) {
            for (let value of answer.values) {
                let choice = value.choice;
                this.value[choice] = this.rows[value.row];
            }
        }
    }
}

app.component('forceRankQuestionPreview', {
    templateUrl: 'templates/components/questionPreviews/forceRankQuestionPreview.html',
    controller: ForceRankQuestionPreviewComponent,
    controllerAs: 'forceRankQuestionPreview',
    bindings: {
        question: '<',
    }
});